import { QueryState } from 'common/enums';
import { IIncident } from 'interfaces/incident.interface';
import { Nullable } from 'utils/Nullable';

export interface IIncidentsState {
  state: QueryState;
  incidents: IIncident[];
  selectIncident: Nullable<IIncident> | undefined;
  page: number;
  pageLimit: number;
  initialPageTotal: number;
  pageTotal: number;
  error: Nullable<string>;
}

export const IncidentsEmptyState: IIncidentsState = {
  state: QueryState.UNDEFINED,
  incidents: [],
  selectIncident: null,
  page: 1,
  pageLimit: parseInt(process.env.REACT_APP_LIST_LIMIT || '10'),
  initialPageTotal: 0,
  pageTotal: 0,
  error: null,
};

export default IncidentsEmptyState;
